(function(){
  var KEY='svila_wishlist';

  function read(){
    try{
      var parsed=JSON.parse(localStorage.getItem(KEY)||'[]');
      var arr=Array.isArray(parsed)?parsed:(parsed&&Array.isArray(parsed.items)?parsed.items:[]);
      var map=new Map();
      arr.forEach(function(raw){var item=normalize(raw);if(item&&item.id&&!map.has(item.id))map.set(item.id,item);});
      return Array.from(map.values());
    }catch(e){return[];}
  }

  function save(items){
    var map=new Map();
    items.forEach(function(raw){var item=normalize(raw);if(item&&item.id&&!map.has(item.id))map.set(item.id,item);});
    var next=Array.from(map.values());
    localStorage.setItem(KEY,JSON.stringify(next));
    updateCount(next.length);
    updateButtons();
    document.dispatchEvent(new CustomEvent('wishlist:sync',{detail:{items:next}}));
    document.dispatchEvent(new CustomEvent('wishlist:updated',{detail:{items:next}}));
    return next;
  }

  function handleFromUrl(value){return String(value||'').replace('/products/','').split('?')[0].split('/').filter(Boolean).pop()||'';}

  function normalize(raw){
    if(!raw)return null;
    if(typeof raw==='string')raw={handle:handleFromUrl(raw)||raw};
    if(typeof raw==='number')raw={id:String(raw),productId:String(raw)};
    if(typeof raw!=='object')return null;
    var productId=raw.productId||raw.product_id||raw.id||'';
    var handle=raw.handle||raw.productHandle||raw.product_handle||handleFromUrl(raw.url||raw.href||'');
    var id=productId?'id:'+productId:(handle?'handle:'+handle:'');
    if(!id)return null;
    return {id:id,productId:String(productId||''),handle:String(handle||''),title:raw.title||raw.productTitle||raw.product_title||String(handle||'Mėgstama prekė'),url:raw.url||raw.href||(handle?'/products/'+handle:'#'),image:raw.image||raw.featured_image||raw.featuredImage||raw.img||'',price:raw.priceText||raw.price_text||raw.price||''};
  }

  function itemFromButton(btn){
    return normalize({
      id:btn.dataset.wishlistId||btn.dataset.productId||btn.dataset.id||'',
      productId:btn.dataset.wishlistId||btn.dataset.productId||btn.dataset.id||'',
      handle:btn.dataset.wishlistHandle||btn.dataset.handle||btn.dataset.productHandle||'',
      title:btn.dataset.wishlistTitle||btn.dataset.title||'',
      url:btn.dataset.wishlistUrl||'',
      image:btn.dataset.wishlistImage||'',
      price:btn.dataset.wishlistPrice||''
    });
  }

  function isWishlistButton(el){
    if(!el)return false;
    var btn=el.closest('[data-wishlist],.js-wishlist');
    if(!btn)return false;
    if(btn.matches('a.wishlist-header-btn[href],a[href="/pages/megstami"]'))return false;
    return btn;
  }

  function hasItem(item,items){return !!item&&items.some(function(saved){return saved.id===item.id;});}

  function setButtonState(btn,active){
    btn.classList.toggle('is-active',!!active);
    btn.classList.toggle('active',!!active);
    btn.classList.toggle('liked',!!active);
    btn.setAttribute('aria-pressed',String(!!active));
    btn.setAttribute('aria-label',active?'Pašalinti iš mėgstamų':'Pridėti prie mėgstamų');
  }

  function updateButtons(){
    var items=read();
    document.querySelectorAll('[data-wishlist],.js-wishlist').forEach(function(btn){
      if(btn.matches('a.wishlist-header-btn[href],a[href="/pages/megstami"]'))return;
      setButtonState(btn,hasItem(itemFromButton(btn),items));
    });
  }

  function updateCount(count){
    if(typeof count!=='number')count=read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent=String(count);
      el.hidden=count<=0;
      el.style.display=count>0?'flex':'none';
    });
  }

  function movePdpButton(){
    var gallery=document.querySelector('.gal-main');
    var btn=document.querySelector('.pdp-title-row .pdp-wishlist-btn');
    if(gallery&&btn&&!gallery.contains(btn)){
      btn.classList.add('pdp-gallery-wishlist');
      gallery.appendChild(btn);
    }
  }

  function quickToggle(btn){
    var item=itemFromButton(btn);
    if(!item)return;
    var items=read();
    var exists=hasItem(item,items);
    setButtonState(btn,!exists);
    btn.classList.add('is-updating');
    save(exists?items.filter(function(saved){return saved.id!==item.id;}):items.concat([item]));
    window.setTimeout(function(){btn.classList.remove('is-updating');},120);
    if(window.svilaShowToast)window.svilaShowToast(exists?'Pašalinta iš mėgstamų':'Pridėta į mėgstamus',false,1200);
  }

  document.addEventListener('click',function(event){
    var btn=isWishlistButton(event.target);
    if(!btn)return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    quickToggle(btn);
  },true);

  function init(){movePdpButton();updateButtons();updateCount();}
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('storage',function(e){if(e.key===KEY)init();});
})();
